module.exports = __webpack_public_path__ + "img/zzyq_qrcode.a92a4feb.jpg";